import React from 'react';
import { SingleSpanTable } from '../SingleSpanTable';
export const TinValidationRequestDataTable = ({ requestData }) => {
    return (React.createElement(SingleSpanTable, { items: [
            {
                label: 'First Name',
                value: requestData.firstName
            },
            {
                label: 'Last Name',
                value: requestData.lastName
            },
            {
                label: 'TIN Type',
                value: requestData.tinType
            },
            {
                label: 'Phone',
                value: requestData.phone
            }
        ], numColumns: 2 }));
};
